import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';

export interface ToastData {
  message: string;
  type: 'success' | 'error';
}

@Component({
  selector: 'app-toast-notification',
  template: `
    <div
      class="flex w-[24rem] items-center gap-3 rounded-sm border-l-4 bg-white px-4 py-3 shadow-xl"
      [class.border-green-700]="data.type === 'success'"
      [class.border-red-600]="data.type === 'error'"
      role="status"
      [attr.aria-live]="data.type === 'error' ? 'assertive' : 'polite'"
    >
      <mat-icon
        aria-hidden="true"
        class="shrink-0"
        [class.text-green-700]="data.type === 'success'"
        [class.text-red-600]="data.type === 'error'"
      >
        {{ data.type === 'success' ? 'check_circle' : 'error' }}
      </mat-icon>
      <p class="flex-1 text-sm leading-5 font-semibold text-gray-800">
        {{ data.message }}
      </p>
      <button
        type="button"
        class="-mr-1 shrink-0 rounded p-1 text-gray-400 transition hover:bg-gray-100 hover:text-gray-600 focus-visible:ring-2 focus-visible:ring-blue-700 focus-visible:outline-none"
        aria-label="Dismiss notification"
        (click)="dismiss()"
      >
        <mat-icon aria-hidden="true" class="text-base leading-none"
          >close</mat-icon
        >
      </button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIconModule],
})
export class ToastNotificationComponent {
  readonly data = inject<ToastData>(MAT_SNACK_BAR_DATA);

  private readonly snackBarRef = inject(MatSnackBarRef);

  dismiss(): void {
    this.snackBarRef.dismiss();
  }
}
